/**
 * @generated SignedSource<<1381eee454a22e43e79f4e5fc19a2c56>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionPublishButtonFragment$data = {
  readonly id: string;
  readonly publishable: boolean;
  readonly version: Semver;
  readonly viewerCanPublishDatasetVersion: boolean;
  readonly " $fragmentType": "DatasetVersionPublishButtonFragment";
};
export type DatasetVersionPublishButtonFragment$key = {
  readonly " $data"?: DatasetVersionPublishButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionPublishButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetVersionPublishButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishable",
      "storageKey": null
    },
    {
      "alias": "viewerCanPublishDatasetVersion",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "PUBLISH_DATASET_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"PUBLISH_DATASET_VERSION\")"
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};

(node as any).hash = "a57d1dc83f5d96f7dcb6d3be9deb36e7";

export default node;
